
(function($) {

	function scrollAnimations(desktopScrollTop, desktopScrollBol) {
		var header = $('#js-header'),
			menu = $('#js-fixed-menu'),
			desktopFixedMenu = $('#js-desktopFixedMenu'),
			windowWidth = $(window).width();

		if ($('body').is('.is-mobile')) {
			var headerH = $('#js-header').outerHeight(), // Height compreso di margini e bordi
				menuH = $('#js-fixed-menu').innerHeight(), // Height senza margini e bordi
				scrollValue = headerH - menuH;

			header.css('height', headerH);

			$(window).scroll(function() {
				scrolltop = $(window).scrollTop();

				if ( scrolltop >= scrollValue) {

					menu.addClass("scroll");
				
				} else {
					menu.removeClass("scroll");
				}            
			});

		} else if ( desktopScrollBol ) {
			header.addClass("scroll");
		}
	}
	
	/*
	 *  Funzioni per PhotoSwiper
	 */
	function addImageSizeForPhotoSwiper() {
		var thumbs = $('img[data-big-size]');
		thumbs.each(function(index) {
			if ($(this).parent('a').length > 0) {
				var isImageLink = $(this).parent('a').attr('href').match(/\.(jpeg|jpg|gif|png)$/);
				if (isImageLink) {
					big_size = $(this).data('big-size');
					link = $(this).parent('a');
					link.attr('data-size', big_size);
					link.wrap('<div class="single-image"></div>');
				}
			}
		});
	}

	function initPhotoSwiper(selector) {
		var galleryItems = $(selector);
		var pswpItems = [];
		galleryItems.each(function(index) {
			var dimensions = $(this).find('a').data('size').split('x');
			var width = parseInt(dimensions[0], 10);
			var height = parseInt(dimensions[1], 10);

			myImage = {
				src: $(this).find('a').attr('href'),
				w: width,
				h: height,
				msrc: $(this).find('img').attr('src')
			};
			 
			pswpItems.push(myImage);
		});


		galleryItems.each(function(index) {
			$(this).click(function(evt) {
				evt.preventDefault();
				openPhotoSwipe(pswpItems, index);
			});
		});
	}

	function openPhotoSwipe(galleryItems, index) {
		var options = {
			index: index
		};
		var pswpElement = $('.pswp')[0];

		var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, galleryItems, options);
		gallery.init();
	}

	function closePhotoswipe() {
		$('.pswp__button--close').click(function() {
			if($('.pswp').hasClass('pswp--open')) {
				$('.pswp').removeClass('pswp--supports-fs pswp--open pswp--notouch pswp--css_animation pswp--svg pswp--animated-in pswp--visible pswp--zoom-allowed pswp--has_mouse');
			}
		});
	
		$(window).scroll(function() {
			if($('.pswp').hasClass('pswp--open')) {
				$('.pswp').removeClass('pswp--supports-fs pswp--open pswp--notouch pswp--css_animation pswp--svg pswp--animated-in pswp--visible pswp--zoom-allowed pswp--has_mouse');
			}
		});
	}

	$(document).ready(function() {

		 scrollAnimations(165, true);
		 
		 addImageSizeForPhotoSwiper();
		 closePhotoswipe();

	});

	$(window).load(function() {
		
		$('.apartment-list .item').equalHeights();
		
		var gallery = $('.gallery');
		if ( gallery.length ) {
			gallery.each(function( index ) {
				
				initPhotoSwiper( "#" + $( this ).attr('id') + " .gallery-item");
			});
		}

		initPhotoSwiper(".entry-content .single-image");
		initPhotoSwiper(".footer-slideshow .zoom");

	});

	$(window).resize(function() {});

})(jQuery);
